const dateToDubble = function (str) {
    if (str < 10) {
        return '0' + str;
    } else {
        return str;
    }
};

const formatDate = function (gmtDate) {
    let date = new Date(gmtDate.replace(/-/g, '/')).getTime(); // 获取UTC时间戳
    let diff_min = new Date().getTimezoneOffset(); // 返回UTC时间和当前计算机上的时间之间相差的分钟数。utc-当地=差分钟数;
    let local_date = new Date(date - diff_min * 60 * 1000); // 获取当地时间
    let local_month = local_date.getMonth() + 1;
    local_month = dateToDubble(local_month);
    let local_timeDetail = ('' + local_date).split(' ');
    let local_ymd = local_timeDetail[3] + '-' + local_month + '-' + local_timeDetail[2];
    // console.log("currentLocalYearmonthday:"+local_ymd);//获取当地的年月日
    let dateToday = new Date();
    //yesterday
    let dateYesterday = new Date();
    dateYesterday.setTime(dateToday.getTime() - 24 * 60 * 60 * 1000);
    let yesterdayMonth = dateYesterday.getMonth() + 1;
    let yesterdayDate = dateYesterday.getDate();
    yesterdayMonth = dateToDubble(yesterdayMonth);
    yesterdayDate = dateToDubble(yesterdayDate);
    let yesterDayGetDate = dateYesterday.getFullYear() + '-' + yesterdayMonth + '-' + yesterdayDate;
    //tomorrow
    let dateTomorrow = new Date();
    dateTomorrow.setTime(dateToday.getTime() + 24 * 60 * 60 * 1000);
    let tomorrowMonth = dateTomorrow.getMonth() + 1;
    let tomorrowDate = dateTomorrow.getDate();
    tomorrowMonth = dateToDubble(tomorrowMonth);
    tomorrowDate = dateToDubble(tomorrowDate);
    let tomorrowGetDate = dateTomorrow.getFullYear() + '-' + tomorrowMonth + '-' + tomorrowDate;
    //today
    let year = dateToday.getFullYear();
    let mon = dateToday.getMonth() + 1;
    let dayy = dateToday.getDate();
    mon = dateToDubble(mon);
    dayy = dateToDubble(dayy);
    let today = year + '-' + mon + '-' + dayy;
    // console.log("today :"+today);
    let date1 = new Date(today);
    let date2 = new Date(local_ymd);
    let date3 = new Date(yesterDayGetDate);
    let date4 = new Date(tomorrowGetDate);

    if (date1.getTime() == date2.getTime()) {
        local_timeDetail[0] = 'Today';
    } else if (date3.getTime() == date2.getTime()) {
        local_timeDetail[0] = 'Yesterday';
    } else if (date4.getTime() == date2.getTime()) {
        local_timeDetail[0] = 'Tomorrow';
    } else {
        local_timeDetail[0] = local_timeDetail[0].toUpperCase();
    }
    // console.log("秒："+local_timeDetail[4].slice(0,5));
    return {
        local_ymd: local_timeDetail[3] + '-' + local_month + '-' + local_timeDetail[2],
        local_hms: local_timeDetail[4].slice(0, 5),
        local_day: local_timeDetail[0],
    };
};
module.exports = formatDate;



// WEBPACK FOOTER //
// ./src/lib/formatDate.js